/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'create_person': 'Person hinzufügen',
    'person': 'Person | Personen',
    'person_created': 'Person erstellt',
    'person_customer_number': 'Kundennummer',
    'person_deleted': 'Person gelöscht | Personen gelöscht',
    'person_email': 'E-Mail',
    'person_first_name': 'Vorname',
    'person_last_name': 'Nachname',
    'person_name': 'Name',
    'person_note': 'Notiz',
    'person_note_private': 'Private Notiz',
    'person_salutation': 'Anrede',
    'person_updated': 'Person aktualisiert',
    'update_person': 'Person bearbeiten'
  },

  /* english */
  en: {
    'create_person': 'Add Person',
    'person': 'Person | Persons',
    'person_created': 'Person Created',
    'person_customer_number': 'Customer Number',
    'person_deleted': 'Person Deleted | Persons deleted',
    'person_email': 'E-Mail',
    'person_first_name': 'First Name',
    'person_last_name': 'Last Name',
    'person_name': 'Name',
    'person_note': 'Note',
    'person_note_private': 'Private Note',
    'person_salutation': 'Salutation',
    'person_updated': 'Person edited',
    'update_person': 'Edit Person'
  }
}
